import forestBg from '../../assets/cat-running/backgrounds/forest-bg.png';
import desertBg from '../../assets/cat-running/backgrounds/desert-bg.png';
import iceBg from '../../assets/cat-running/backgrounds/ice-bg.png';
import volcanoBg from '../../assets/cat-running/backgrounds/volcano-bg.png';

import forestHurdleA from '../../assets/cat-running/obstacles/forest/hurdle-a.png';
import forestHurdleB from '../../assets/cat-running/obstacles/forest/hurdle-b.png';
import forestHurdleC from '../../assets/cat-running/obstacles/forest/hurdle-c.png';
import desertHurdleA from '../../assets/cat-running/obstacles/desert/hurdle-a.png';
import desertHurdleB from '../../assets/cat-running/obstacles/desert/hurdle-b.png';
import desertHurdleC from '../../assets/cat-running/obstacles/desert/hurdle-c.png';
import iceHurdleA from '../../assets/cat-running/obstacles/ice/hurdle-a.png';
import iceHurdleB from '../../assets/cat-running/obstacles/ice/hurdle-b.png';
import iceHurdleC from '../../assets/cat-running/obstacles/ice/hurdle-c.png';
import volcanoHurdleA from '../../assets/cat-running/obstacles/volcano/hurdle-a.png';
import volcanoHurdleB from '../../assets/cat-running/obstacles/volcano/hurdle-b.png';
import volcanoHurdleC from '../../assets/cat-running/obstacles/volcano/hurdle-c.png';
import crow01 from '../../assets/cat-running/obstacles/common/crow-01.png';
import crow02 from '../../assets/cat-running/obstacles/common/crow-02.png';

import characterARun01 from '../../assets/cat-running/characters/a/run-01.png';
import characterARun02 from '../../assets/cat-running/characters/a/run-02.png';
import characterADeath from '../../assets/cat-running/characters/a/death.png';
import characterAKickboard from '../../assets/cat-running/characters/a/kickboard.png';
import characterAKickboardDeath from '../../assets/cat-running/characters/a/kickboard-death.png';
import characterBRun01 from '../../assets/cat-running/characters/b/run-01.png';
import characterBRun02 from '../../assets/cat-running/characters/b/run-02.png';
import characterBDeath from '../../assets/cat-running/characters/b/death.png';
import characterBKickboard from '../../assets/cat-running/characters/b/kickboard.png';
import characterBKickboardDeath from '../../assets/cat-running/characters/b/kickboard-death.png';
import characterCRun01 from '../../assets/cat-running/characters/c/run-01.png';
import characterCRun02 from '../../assets/cat-running/characters/c/run-02.png';
import characterCDeath from '../../assets/cat-running/characters/c/death.png';
import characterCKickboard from '../../assets/cat-running/characters/c/kickboard.png';
import characterCKickboardDeath from '../../assets/cat-running/characters/c/kickboard-death.png';

import churu from '../../assets/cat-running/items/churu.png';
import magnet from '../../assets/cat-running/items/magnet.png';
import shield from '../../assets/cat-running/items/shield.png';
import snack from '../../assets/cat-running/items/snack.png';

import gameOver from '../../assets/cat-running/ui/game-over.png';
import youWin from '../../assets/cat-running/ui/you-win.png';

import battleSwords from '../../assets/cat-running/battle/icon-swords.png';
import battleCopy from '../../assets/cat-running/battle/icon-copy.png';
import battleFriends from '../../assets/cat-running/battle/icon-friends.png';
import battleAvatarCat from '../../assets/cat-running/battle/avatar-cat.png';
import battleSnack from '../../assets/cat-running/battle/icon-snack.png';
import battleLock from '../../assets/cat-running/battle/icon-lock.png';
import battleRandom from '../../assets/cat-running/battle/icon-random.png';
import battleWin from '../../assets/cat-running/battle/icon-win.png';
import battleSearch from '../../assets/cat-running/battle/icon-search.png';
import battleInvite from '../../assets/cat-running/battle/icon-invite.png';
import battleChat from '../../assets/cat-running/battle/icon-chat.png';
import battleLink from '../../assets/cat-running/battle/icon-link.png';
import battleGift from '../../assets/cat-running/battle/icon-gift.png';

export const CAT_RUNNING_STAGE_ORDER = ['forest', 'desert', 'ice', 'volcano'];

export const CAT_RUNNING_BACKGROUNDS = {
  forest: forestBg,
  desert: desertBg,
  ice: iceBg,
  volcano: volcanoBg,
};

export const CAT_RUNNING_OBSTACLES = {
  forest: [forestHurdleA, forestHurdleB, forestHurdleC],
  desert: [desertHurdleA, desertHurdleB, desertHurdleC],
  ice: [iceHurdleA, iceHurdleB, iceHurdleC],
  volcano: [volcanoHurdleA, volcanoHurdleB, volcanoHurdleC],
  common: {
    crow: [crow01, crow02],
  },
};

export const CAT_RUNNING_CHARACTERS = {
  a: {
    run: [characterARun01, characterARun02],
    death: characterADeath,
    kickboard: characterAKickboard,
    kickboardDeath: characterAKickboardDeath,
  },
  b: {
    run: [characterBRun01, characterBRun02],
    death: characterBDeath,
    kickboard: characterBKickboard,
    kickboardDeath: characterBKickboardDeath,
  },
  c: {
    run: [characterCRun01, characterCRun02],
    death: characterCDeath,
    kickboard: characterCKickboard,
    kickboardDeath: characterCKickboardDeath,
  },
};

export const CAT_RUNNING_ITEMS = {
  churu,
  magnet,
  shield,
  snack,
};

export const CAT_RUNNING_UI = {
  gameOver,
  youWin,
};

export const CAT_RUNNING_BATTLE = {
  swords: battleSwords,
  copy: battleCopy,
  friends: battleFriends,
  avatarCat: battleAvatarCat,
  snack: battleSnack,
  lock: battleLock,
  random: battleRandom,
  win: battleWin,
  search: battleSearch,
  invite: battleInvite,
  chat: battleChat,
  link: battleLink,
  gift: battleGift,
};

export const CAT_RUNNING_ASSETS = {
  backgrounds: CAT_RUNNING_BACKGROUNDS,
  obstacles: CAT_RUNNING_OBSTACLES,
  characters: CAT_RUNNING_CHARACTERS,
  items: CAT_RUNNING_ITEMS,
  ui: CAT_RUNNING_UI,
  battle: CAT_RUNNING_BATTLE,
  stageOrder: CAT_RUNNING_STAGE_ORDER,
};

export default CAT_RUNNING_ASSETS;
